module.exports = __webpack_public_path__ + "static/background-image-triple-a42ec8adf4bb46d5d49bf440a178c168.jpg";